import { IconPound } from '@iwoca/icons';
import { Button, Spinner } from '@iwoca/orion';

import { HookFormDropDown } from '../../../components/Dropdown/Dropdown';
import { formatCurrency } from '../../../components/Input/formatCurrency';
import { HookFormInput } from '../../../components/Input/Input';

const LOAN_REASONS = [
  { label: 'Inventory/stock purchase', value: 'stock_purchase' },
  { label: 'Bridging loan', value: 'bridging_loan' },
  { label: 'Marketing', value: 'marketing' },
  {
    label: 'Equipment/building purchase',
    value: 'equipment_purchase',
  },
  { label: 'Pay a due bill', value: 'pay_bill' },
  { label: 'Pay staff', value: 'pay_staff' },
  { label: 'Refinancing debt', value: 'refinancing_debt' },
  { label: 'Other purpose', value: 'other' },
] as const;

export const FormContent = ({ isSubmitting }: { isSubmitting: boolean }) => {
  return (
    <>
      <div className="my-l">
        <HookFormInput
          name="amount"
          iconLeft={<IconPound />}
          formatter={formatCurrency}
          label="How much do you need?"
          placeholder="Enter an amount between £1,000 and £1,000,000"
        />
      </div>
      <div className="my-l">
        <HookFormDropDown
          name="purpose"
          labelText="What is your main reason for requesting a loan?"
        >
          <option disabled hidden value="">
            Please choose an option
          </option>
          {LOAN_REASONS.map((purpose) => (
            <option key={purpose.value} value={purpose.value}>
              {purpose.label}
            </option>
          ))}
        </HookFormDropDown>
      </div>
      <div className="my-l">
        <HookFormInput
          className="mb-l"
          iconLeft={<IconPound />}
          name="turnover"
          formatter={formatCurrency}
          label=" What was your last 12 months turnover?"
          placeholder="Enter an amount between £1,000 and £1,000,000"
        />
      </div>
      <Button
        type="submit"
        className="mt-2xl min-w-[150px]"
        disabled={isSubmitting}
      >
        {isSubmitting ? <Spinner /> : 'Next'}
      </Button>
    </>
  );
};
